import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import styled from '@emotion/styled';
import SubNavigation from 'components/Navigation/SubNavigation';
import {
  selectCanEditContactObjects,
  selectCanEditSomeCustomObjects,
  selectCanEditTeamMemebersFields,
} from 'store/authentication/selectors';
import { setError } from 'store/errors';
import getRoutes from './routes';
import { SubNavWrapper } from '../../styled';

const StyledSubNavigation = styled(SubNavigation)`
  && a {
    padding-bottom: 10px !important;
  }
`;

export default function CustomFieldsPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const routes = getRoutes();
  const canEditCustomObjects = useSelector(selectCanEditSomeCustomObjects);
  const canEditContactObjects = useSelector(selectCanEditContactObjects);
  const canEditTeammembersFields = useSelector(selectCanEditTeamMemebersFields);

  const filteredRoutes = useMemo(() => {
    return Object.entries(routes).reduce((acc, [key, route]) => {
      if (key === 'contacts' && !canEditContactObjects) {
        return acc;
      }
      if (key === 'custom-objects/:id?' && !canEditCustomObjects) {
        return acc;
      }
      if (key === 'teammembers' && !canEditTeammembersFields) {
        return acc;
      }
      acc[key] = route;
      return acc;
    }, {});
  }, [
    routes,
    canEditContactObjects,
    canEditCustomObjects,
    canEditTeammembersFields,
  ]);

  useEffect(() => {
    // treat `/settings/custom-fields` and `/settings/custom-fields/contacts` the same
    if (location.pathname === '/settings/custom-fields') {
      history.replace(`${location.pathname}/contacts${location.search}`);
    } else if (
      location.pathname === '/settings/custom-fields/contacts' &&
      !canEditContactObjects
    ) {
      if (canEditCustomObjects) {
        history.replace(
          `/settings/custom-fields/custom-objects${location.search}`
        );
      } else {
        if (canEditTeammembersFields) {
          history.replace(
            `/settings/custom-fields/teammembers${location.search}`
          );
        } else {
          dispatch(setError({ code: 404 }));
        }
      }
    } else if (
      (location.pathname.startsWith('/settings/custom-fields/contacts') &&
        !canEditContactObjects) ||
      (location.pathname.startsWith('/settings/custom-fields/custom-objects') &&
        !canEditCustomObjects) ||
      (location.pathname.startsWith('/settings/custom-fields/teammembers') &&
        !canEditTeammembersFields)
    ) {
      // handling a direct link to a contact field like `/settings/custom-fields/contacts/${id}` - just show the error page
      dispatch(setError({ code: 404 }));
    }
  }, [
    canEditContactObjects,
    canEditCustomObjects,
    canEditTeammembersFields,
    history,
    location,
    dispatch,
  ]);

  return (
    <>
      <SubNavWrapper>
        <StyledSubNavigation
          small
          id="sectionnav"
          routes={filteredRoutes}
          currentSearch={location.search}
        />
      </SubNavWrapper>
      <Switch>
        {Object.entries(routes).map(([key, route]) => {
          return (
            <Route
              key={key}
              path={route.path}
              exact={route.exact !== false}
              component={route.component}
            />
          );
        })}
      </Switch>
    </>
  );
}
